module.exports = __webpack_public_path__ + "static/media/risks.ecadf79a.svg";